// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ecran bloquant "compte non rattache" — meme structure que SuspensionModal (FRONT-19),
   tonalite orange (information, pas sanction) au lieu du rouge de la suspension. */

.rattachement-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(4px);
}

.rattachement-modal {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 560px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: rattachementSlideIn 0.3s ease-out;
  display: flex;
  flex-direction: column;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

@keyframes rattachementSlideIn {
  from { opacity: 0; transform: translateY(-30px); }
  to   { opacity: 1; transform: translateY(0); }
}

.rattachement-modal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 30px;
  border-bottom: 1px solid #e5e7eb;
}

.rattachement-modal-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  background-color: #fff7ed;
  border-radius: 50%;
}

.rattachement-modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.rattachement-modal-body {
  padding: 30px;
}

.rattachement-text-primary {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0 0 8px 0;
}

.rattachement-text-secondary {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.rattachement-contact {
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
}

.rattachement-contact p {
  margin: 0 0 6px 0;
  color: #6b7280;
  font-size: 13px;
}

.rattachement-contact-link {
  color: #f97316;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
}

.rattachement-contact-link:hover {
  color: #ea580c;
  text-decoration: underline;
}

.rattachement-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 30px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/composants/RattachementModal/RattachementModal.css"],"names":[],"mappings":"AAAA;mFACmF;;AAEnF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,+EAA+E;AACjF;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC","sourcesContent":["/* Ecran bloquant \"compte non rattache\" — meme structure que SuspensionModal (FRONT-19),\n   tonalite orange (information, pas sanction) au lieu du rouge de la suspension. */\n\n.rattachement-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n  backdrop-filter: blur(4px);\n}\n\n.rattachement-modal {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 560px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: rattachementSlideIn 0.3s ease-out;\n  display: flex;\n  flex-direction: column;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n@keyframes rattachementSlideIn {\n  from { opacity: 0; transform: translateY(-30px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.rattachement-modal-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 30px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.rattachement-modal-header-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  background-color: #fff7ed;\n  border-radius: 50%;\n}\n\n.rattachement-modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.rattachement-modal-body {\n  padding: 30px;\n}\n\n.rattachement-text-primary {\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.6;\n  margin: 0 0 8px 0;\n}\n\n.rattachement-text-secondary {\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.6;\n  margin: 0 0 24px 0;\n}\n\n.rattachement-contact {\n  background-color: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 16px;\n}\n\n.rattachement-contact p {\n  margin: 0 0 6px 0;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.rattachement-contact-link {\n  color: #f97316;\n  font-weight: 600;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.rattachement-contact-link:hover {\n  color: #ea580c;\n  text-decoration: underline;\n}\n\n.rattachement-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 30px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
